import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of, Subscriber } from 'rxjs';

//SERVICES
import { ConfigService } from '../services/config.service';

//MODELS
import { DynamicList } from '../models/dynamic-list.interface';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { ExcursionItinerary } from '../models/excursion-itineraries.interface';
import { SortService } from '../services/sort.service';



//NOTE: this got named before we changed it to Travel Boards


//@Injectable({providedIn: SharedModule})
@Injectable({providedIn: 'root'})
export class CompassAPIExcursionItineraryService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	public currentBoard: ExcursionItinerary;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService,
		private _sortService: SortService
	) { 

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'excursionitineraries';//travelboards
	}


    /**
	 * Get Excursion Itineraries
	 * @param search 
	 * @param limit 
	 * @param offset 
	 * @param sortByModified 
	 * @param userId 
	 * @returns 
	*/
	public getExcursionItineraries (
		search: string = null, 
		limit: number = null, 
		offset: number = null, 
		sortByModified: boolean = false, 
		userId: string
		){// = null
		let url = new URL(this.baseUrl);
		if(search) url.searchParams.append('SearchTerm', search);
		if(limit) url.searchParams.append('limit', String(limit));
		if(offset) url.searchParams.append('offset', String(offset));
		if(userId) url.searchParams.append('userId', String(userId));
		//url.searchParams.append('RequestSiteContext', this.config.RequestSiteContext);
		//console.log('API.getExcursionItineraries().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getExcursionItineraries.res:', res);
				if(res.status == CompassApiStatusEnum.ok && res.total > 0) {
					let items: ExcursionItinerary[] = res.results;
					if(sortByModified) {
						items = this.sortLatestBoards(items);
					}
					const getResults: CompassApiGetResults = {
						total: res.total,
						results: items
					}
					return getResults;
				} else {
					return res;//null;
				}
			}));
	}



	/**
	 * Get ExcursionItinerary by ID
	 * @param id
	 * @returns
	*/
	public getExcursionItineraryById (id: string): Observable<ExcursionItinerary>{
		//let url = this.baseUrl + '/' + id;
		let url = new URL(this.baseUrl + '/' + id);
		//console.log('API.getExcursionItineraryById().url:', String(url));
		//console.log('API.getDynamicListById().config.headers:', this.config.headers);

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getExcursionItineraryById.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const item: ExcursionItinerary = res.result;
					return item;
				} else {
					return res;//uses error
				}
			}));
	}



	/**
	 * Put (update) Excursion Itineraries
	 * @param id
	 * @param board:ExcursionItinerary
	 * @returns
	*/
	public putExcursionItineraries (id: string, board: ExcursionItinerary){
		let url = this.baseUrl + '/' + id,
			body = board,
			options = {
				headers: this.config.headers,
			};
		// console.log('API.putExcursionItineraries().url:', url);
		// console.log('API.putExcursionItineraries().board:', board);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putExcursionItineraries.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					this.currentBoard = board;
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}



	/**
	 * POST Excursion Itineraries
	 * @param board:ExcursionItinerary
	 * @returns
	*/
	public postExcursionItineraries (board: ExcursionItinerary){
		let url = this.baseUrl + '/',
			body = board,
			options = {
				headers: this.config.headers,
			};
		// console.log('API.putExcursionItineraries().url:', url);
		// console.log('API.putExcursionItineraries().board:', board);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putExcursionItineraries.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					this.currentBoard = board;
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Excursion Itineraries
	 * @param boardId
	 * @returns
	*/
	public deleteExcursionItineraries (boardId: string){
		let url = this.baseUrl + '/' + boardId,
			//body = board,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.deleteExcursionItineraries().url:', url);
		// console.log('API.deleteExcursionItineraries().board:', board);

		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteExcursionItineraries.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					this.currentBoard = null;
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}

	
	public postProductsAssets (excursionId:string, data:any){
		let url = this.baseUrl + '/' + excursionId + '/assets',
			body = data,
			options = {
				headers: this.config.headersNoContentType,
			};

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postProductsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.results;
				} else {
					return res;//uses error
				}
			}));
	}


	public getLatestBoard(userId: string) {
		//console.log('TravelBoardComponent.getLatestBoard');

		return new Promise((resolve, reject) => {
			//console.log('getLatestBoard.currentBoard:', this.currentBoard);

			if(!this.currentBoard) {
				//console.log('getLatestBoard.hit API, get all, sort by latest');

				this.getExcursionItineraries(null, null, null, true, userId)
					.pipe(take(1))
					.subscribe((res)=> {
						//console.log('getLatestBoard.getExcursionItineraries.res:', res);
						if(res?.results){
							const boards: ExcursionItinerary[] = this.sortLatestBoards(res.results);
							this.currentBoard = boards[0];
							resolve(this.currentBoard);
						}
						//console.log('no boards found.');
						reject(null);

					});

			} else {
				//console.log('getLatestBoard.return this.currentBoard');
				resolve(this.currentBoard);
			}

		});
	}


	public setLatestBoard(board: ExcursionItinerary){
		//console.log('setLatestBoard');
		this.currentBoard = board;
	}


	public clearLatestBoard(){
		this.currentBoard = null;
		//console.log('clearLatestBoard:', this.currentBoard);
		
	}




	public sortLatestBoards(boards: ExcursionItinerary[]) {
		//console.log('sortLatestBoards', boards);

		let boardsSorted: ExcursionItinerary[] = this._sortService.sortArray(boards, ['modifiedOn'], true);

		//console.log('boardsSorted:', boardsSorted);

		return boardsSorted;
	}

}